var React = require('react');

function IconHidePassword (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("linearGradient",{"id":"hide-a","x1":"100%","x2":"0%","y1":"0%","y2":"100%"},[React.createElement("stop",{"offset":"0%","stopColor":"#593AEC","key":0}),React.createElement("stop",{"offset":"100%","stopColor":"#C54887","key":1})])),React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"url(#hide-a)","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","transform":"translate(-228 -887)","key":1},React.createElement("path",{"d":"M250.127 894.563c2.652 1.916 4.33 4.035 4.33 4.035s-5.597 7.065-12.5 7.065c-1.13 0-2.223-.189-3.263-.504M233.769 902.62c-2.642-1.913-4.312-4.022-4.312-4.022s5.596-7.065 12.5-7.065c.934 0 1.846.13 2.722.353M237.609 898.598a4.348 4.348 0 0 1 4.348-4.348M246.304 898.598a4.348 4.348 0 0 1-4.347 4.348M252.554 888l-21.195 21.196"}))]);
}

IconHidePassword.displayName = "IconHidePassword";

IconHidePassword.defaultProps = {"width":"28","height":"24","viewBox":"0 0 28 24"};

module.exports = IconHidePassword;

IconHidePassword.default = IconHidePassword;



//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/iconHidePassword.svg
// module id = 1090
// module chunks = 22